import { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

export function useUserProfile(user) {
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || !user.email) {
      setUserProfile(null);
      setLoading(false);
      return;
    }

    const fetchUserProfile = async () => {
      try {
        const usersRef = collection(db, 'users');
        const q = query(usersRef, where('email', '==', user.email));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const userData = querySnapshot.docs[0].data();
          setUserProfile({
            name: userData.name || user.displayName || 'User',
            email: user.email,
            photoURL: userData.photoURL || user.photoURL || null
          });
        } else {
          // Fallback to auth user data
          setUserProfile({
            name: user.displayName || 'User',
            email: user.email,
            photoURL: user.photoURL || null
          });
        }
      } catch (error) {
        console.error('Error fetching user profile:', error);
        // Fallback to auth user data
        setUserProfile({
          name: user.displayName || 'User',
          email: user.email,
          photoURL: user.photoURL || null
        });
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [user]);

  return { userProfile, loading };
}

// Helper function to get initials from name
export function getInitials(name) {
  if (!name || name === 'User') return 'U';
  
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
